// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ae0ecb2d","821":"75b23882"}[chunkId] + ".chunk.js";
};